<div class="fullscreen-bg" [ngStyle]="{ 'background-image': 'url(' + appService.fullscreenBG + ')' }"></div>
